import React from "react";
const Industrypage=React.lazy(()=>import('./Industrypage'));
const Manufacturing=React.lazy(()=>import('./Manufacturing'));
const Healthcare=React.lazy(()=>import('./Healthcare'));
const Startup=React.lazy(()=>import('./Startup'));
const Ecommerce=React.lazy(()=>import('./Ecommerce'));
const Datacenter=React.lazy(()=>import('./Datacenter'));
const Fintech=React.lazy(()=>import('./Fintech'))
const Banking=React.lazy(()=>import('./Banking'));
const SMEs=React.lazy(()=>import('./SMEs'));

export {
    Industrypage,
    Manufacturing,
    Healthcare,
    Startup,
    Ecommerce,
    Datacenter,
    Fintech,
    Banking,
    SMEs
}